// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserActivityManagementFilledSvg from "@fishx/icons-svg/es/asn/UserActivityManagementFilled";
import FishxIcon from '../components/FishxIcon';

var UserActivityManagementFilled = function UserActivityManagementFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserActivityManagementFilledSvg
  }));
};

UserActivityManagementFilled.displayName = 'UserActivityManagementFilled';
export default React.forwardRef(UserActivityManagementFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserActivityManagementFilled.js
// module id = 4344
// module chunks = 0